import * as React from "react";
import Scroll from "src/packages/scroll/Scroll";
import Code from "src/components/Code";
import CodeBox from "src/components/CodeBox";
import Space from "src/components/Space";
import { renderString } from "src/utils/renderCode";

const componentName = "ScrollExample";

class ScrollExample extends React.Component {
  public static displayName = componentName;

  public render() {
    return (
      <div className="scroll-example">
        <section>
          <h1>Scroll 滚动条</h1>
          <p className="text">自定义滚动条。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">当需要使用自定义滚动条代替浏览器自带滚动条时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div
            className="container"
            style={{ display: "block", height: "600px" }}
          >
            <Scroll
              style={{ border: "1px solid rgba(0,0,0,0.15)" }}
              yBarStyle={{ width: "14px", height: "200px" }}
            >
              <div>
                {Array.from({ length: 100 }).map((a, index) => (
                  <div key={index}>{"scroll-" + index}</div>
                ))}
              </div>
            </Scroll>
          </div>
          <CodeBox title="基本用法" description="最基本的用法。">
            {renderString(`import { Scroll } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Scroll&gt;`} />
            <Space count={4} />
            <span className="label">&lt;</span>
            <span className="htmltag">div</span>
            <span className="label"> /</span>
            <span className="label">&gt;</span>
            <br />
            <Code code={`&lt;/Scroll&gt;`} />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>scrollBarVisible</td>
              <td className="des">是否始终展示滚动条</td>
              <td className="type">boolean</td>
              <td>false</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义外层容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义外层容器样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
            <tr>
              <td>trackClassName</td>
              <td className="des">自定义滚动条滑块轨道容器类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>trackStyle</td>
              <td className="des">自定义滚动条滑块轨道容器样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
            <tr>
              <td>scroollBarClassName</td>
              <td className="des">自定义滚动条滑块类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>scrollBarStyle</td>
              <td className="des">自定义滚动条滑块样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ScrollExample;



// WEBPACK FOOTER //
// ./src/examples/Scroll.example.tsx